import { jsxs, jsx } from "react/jsx-runtime";
import { useContext, Children } from "react";
import PropTypes from "prop-types";
import { cloneValidElement } from "@reach/utils";
import { DropdownMenuSectionWrapper, DropdownMenuSectionHeading } from "./dropdown-menu-section.styles.es.js";
import { dropdownMenuContext } from "./dropdown-menu-context.es.js";
const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired,
  title: PropTypes.string
};
const defaultProps = {
  title: void 0
};
const DropdownMenuSection = ({ children, title, ...restProps }) => {
  const { magnitude } = useContext(dropdownMenuContext);
  return /* @__PURE__ */ jsxs(DropdownMenuSectionWrapper, { role: "none", ...restProps, children: [
    title && /* @__PURE__ */ jsx(DropdownMenuSectionHeading, { role: "none", $magnitude: magnitude, children: title }),
    Children.map(
      children,
      (child) => cloneValidElement(child, { $inSection: true })
    )
  ] });
};
DropdownMenuSection.propTypes = propTypes;
DropdownMenuSection.defaultProps = defaultProps;
export {
  DropdownMenuSection
};
